import {asin, cos, sin} from "../math";

export function cylindricalEqualAreaRaw(phi0) {
  var cosPhi0 = cos(phi0);

  function forward(lambda, phi) {
    return [lambda * cosPhi0, sin(phi) / cosPhi0];
  }

  forward.invert = function(x, y) {
    return [x / cosPhi0, asin(y * cosPhi0)];
  };

  return forward;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-geo/src/projection/cylindricalEqualArea.js
// module id = 300
// module chunks = 0 1 2 3 4